const bankIconURLMap = {
  // via Stripe
  abn_amro: 'abnamro',
  asn_bank: 'asn',
  bunq: 'bunq',
  handelsbanken: 'handelsbanken',
  ing: 'ING',
  knab: 'khab',
  moneyou: 'moneyou',
  rabobank: 'rabobank',
  regiobank: 'regiobank',
  sns_bank: 'sns',
  triodos_bank: 'triodos',
  van_lanschot: 'vanlanschot',

  // via WP
  '0031': 'abnamro',
  '0761': 'asn',
  '0802': 'bunq',
  '0721': 'ING',
  '0801': 'khab',
  '0803': 'moneyou',
  '0021': 'rabobank',
  '0771': 'regiobank',
  '0751': 'sns',
  '0511': 'triodos',
  '0161': 'vanlanschot',
};

// TODO: move to Metadata after this Jira; https://jira.wixpress.com/browse/PAY-1919
const baseUrl =
  'https://static.parastorage.com/services/cashier-payments-widget/1.725.0/assets/img/bank-icons/';

export const getBankIconURL = (bankId: string): string | undefined => {
  if (bankIconURLMap[bankId]) {
    return `${baseUrl}ic_ideal_banks_${bankIconURLMap[bankId]}.svg`;
  }
};
